import { _ as e } from "./extends-093996c9.js";
import t from "react";

var c = function c(_c) {
  var o = _c.dark,
      l = void 0 === o ? "#000000" : o,
      r = _c.light,
      s = void 0 === r ? "#ffffff" : r,
      n = _c.schema,
      i = {
    isotypebox: l,
    isotypeletter: l,
    letters: l
  };
  return "light" === (void 0 === n ? "common" : n) && (i.isotypebox = s, i.isotypeletter = s, i.letters = s), t.createElement("svg", e({
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.2 78.3"
  }, _c), t.createElement("g", {
    fill: i.letters
  }, t.createElement("path", {
    d: "M146.5,77.2h2.4V21.6h-2.4V77.2z M208.6,77.2V1.1h-2.4v72.2l-48.6-60.8l-1.1,2.2l50,62.6L208.6,77.2 L208.6,77.2z"
  }), t.createElement("polygon", {
    points: "149.1,19 158.1,0.4 84.7,0.4 62.2,0.4 43,44 22.5,0.4 0.9,0.4 0.9,77.2 22.6,77.2 22.5,38.5 37.6,77.2 48.1,77.2 63.1,38.5 63.1,77.2 84.7,77.2 84.7,19 105.5,19 105.5,18.9 105.5,18.9 105.5,77.2 129.1,77.2 129.1,19 "
  }), t.createElement("g", null, t.createElement("path", {
    d: "M421,76.7c3.2-1.1,6-2.5,8.2-4.3s4-4,5.2-6.4c1.2-2.5,1.8-5.1,1.8-7.9v-0.2c0-2.6-0.4-4.9-1.3-7 s-2.3-3.9-4.4-5.5s-4.8-3.1-8.1-4.4c-3.4-1.3-7.5-2.4-12.4-3.4c-4.7-0.9-8.6-2-11.7-3.1s-5.6-2.4-7.5-3.8c-1.9-1.4-3.3-3-4.1-4.8 c-0.8-1.8-1.2-3.9-1.2-6.2v-0.2c0-2.2,0.5-4.4,1.6-6.5c1-2.1,2.6-3.9,4.5-5.5c2-1.6,4.3-2.9,7-3.8s5.7-1.4,9.1-1.4 c4.7,0,9.1,0.8,13.2,2.3c4.1,1.6,7.9,3.6,11.3,6.1l1.5-2c-3.5-2.7-7.4-4.8-11.8-6.4S412.8,0,407.8,0c-3.6,0-6.9,0.5-9.9,1.5 s-5.6,2.4-7.8,4.2c-2.2,1.8-3.9,3.8-5.2,6.2c-1.2,2.4-1.8,4.9-1.8,7.6v0.2c0,2.7,0.5,5.1,1.4,7.1c0.9,2.1,2.4,3.9,4.5,5.5 s4.7,3,8,4.2s7.3,2.3,12,3.2c4.8,1,8.8,2.1,12,3.2c3.2,1.1,5.8,2.4,7.7,3.9c1.9,1.5,3.2,3.1,4,4.9c0.8,1.8,1.2,3.9,1.2,6.3v0.2 c0,2.5-0.5,4.9-1.6,7.1c-1.1,2.2-2.6,4.1-4.7,5.7c-2,1.6-4.5,2.8-7.4,3.8c-2.9,0.9-6.1,1.4-9.7,1.4c-5.6,0-10.8-1-15.5-3 c-4.8-2-9.1-4.9-13-8.7l-1.7,1.7c4.1,3.9,8.7,6.9,13.7,9s10.5,3.2,16.3,3.2C414.2,78.3,417.8,77.8,421,76.7"
  })), t.createElement("polygon", {
    points: "302.8,77.8 304.9,77.8 327.9,5.3 351.1,77.8 353.1,77.8 378.4,1.1 376,1.1 352.1,74.1 328.9,0.9 327.1,0.9 303.9,73.9 280,1.1 277.5,1.1 "
  }), t.createElement("polygon", {
    points: "221.7,77.2 275.4,77.2 275.4,75 224.1,75 224.1,40 270.2,40 270.2,37.8 224.1,37.8 224.1,3.3 274.8,3.3 274.8,1.1 221.7,1.1 "
  })));
};

export { c as MtNews };